/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 31.08.17.
 */

import React from "react";
import PropTypes from "prop-types";

import {
    getWidget,
    getUiOptions,
    optionsList,
    getDefaultRegistry,
} from "react-jsonschema-form/lib/utils";

class RangeField extends React.Component {
    static propTypes = {
        schema: PropTypes.object.isRequired,
        uiSchema: PropTypes.object.isRequired,
        idSchema: PropTypes.object,
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func,
        onFocus: PropTypes.func,
        formData: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
        registry: PropTypes.shape({
            widgets: PropTypes.objectOf(
                PropTypes.oneOfType([PropTypes.func, PropTypes.object])
            ).isRequired,
            fields: PropTypes.objectOf(PropTypes.func).isRequired,
            definitions: PropTypes.object.isRequired,
            formContext: PropTypes.shape({
                expanded: PropTypes.bool,
                expandedCallback: PropTypes.func,
                onSubmit: PropTypes.func,
                locale: PropTypes.string,
                params: PropTypes.shape({
                    path: PropTypes.string.isRequired,
                    resource: PropTypes.string.isRequired,
                    action: PropTypes.oneOf(["list","new","view","edit","delete"]).isRequired,
                    id: PropTypes.string,
                    query: PropTypes.object,
                    parentPath: PropTypes.string,
                    parentResource: PropTypes.string,
                    parentAction: PropTypes.oneOf(["list","new","view","edit","delete"]),
                    parentId: PropTypes.string,
                    parentField: PropTypes.string
                })
            }).isRequired,
        }),
        required: PropTypes.bool,
        disabled: PropTypes.bool,
        readonly: PropTypes.bool,
        autofocus: PropTypes.bool
    };

    static defaultProps = {
        uiSchema: {},
        disabled: false,
        readonly: false,
        autofocus: false
    };

    constructor(props) {
        super(props);
        this.state = {};
        this.onChange1 = this.onChange1.bind(this);
        this.onChange2 = this.onChange2.bind(this);
        // this.onBlur = this.onBlur.bind(this);
    }

    onChange1(value) {
        this.props.onChange([value, this.props.formData && this.props.formData[1]]);
    }

    onChange2(value) {
        this.props.onChange([this.props.formData && this.props.formData[0], value]);
    }

    render() {
        const {
            schema,
            name,
            uiSchema,
            idSchema,
            formData,
            required,
            disabled,
            readonly,
            autofocus,
            onChange,
            onBlur,
            onFocus,
            registry = getDefaultRegistry(),
        } = this.props;
        const { title, format } = schema;
        const { widgets, formContext } = registry;
        const enumOptions = (Array.isArray(schema.enum) ? optionsList(schema) : []);
        const defaultWidget = format || (Array.isArray(schema.enum) ? "select" : "text");
        const { widget = defaultWidget, placeholder = "", ...options } = getUiOptions(
            uiSchema
        );
        const Widget = getWidget(schema, widget, widgets);

        return (
            <div className="form-inline">
                <Widget
                    options={{ ...options, enumOptions }}
                    schema={schema.items}
                    id={idSchema && idSchema.$id + "_1"}
                    label={title === undefined ? name : title}
                    value={formData && formData[0]}
                    onChange={this.onChange1}
                    onBlur={onBlur}
                    onFocus={onFocus}
                    required={required}
                    disabled={disabled}
                    readonly={readonly}
                    formContext={formContext}
                    autofocus={autofocus}
                    registry={registry}
                    placeholder={placeholder}
                />
                {" - "}
                <Widget
                    options={{ ...options, enumOptions }}
                    schema={schema.items}
                    id={idSchema && idSchema.$id + "_2"}
                    label={title === undefined ? name : title}
                    value={formData && formData[1]}
                    onChange={this.onChange2}
                    onBlur={onBlur}
                    onFocus={onFocus}
                    required={required}
                    disabled={disabled}
                    readonly={readonly}
                    formContext={formContext}
                    autofocus={autofocus}
                    registry={registry}
                    placeholder={placeholder}
                />
            </div>
        );
    }
}

export default RangeField;
